import { InertiaApp } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import DGrid from '@/components/grid/d-grid'
import {
  Grid,
  GridToolbar,
  GridNoRecords ,
  GridColumnMenuSort,
  GridColumnMenuFilter
} from '@progress/kendo-vue-grid'
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import Toasted from 'vue-toasted';
import LoadingButton from '@/Shared/LoadingButton'

import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import { NumericTextBox, Input } from '@progress/kendo-vue-inputs';
// import { DateInput } from '@progress/kendo-vue-dateinputs';
import { DatePicker } from '@progress/kendo-vue-dateinputs';

require('./bootstrap');
import Print from 'vue-print-nb'
// Global instruction 

Vue.use(Print);
Vue.mixin({ methods: { route: window.route } })
Vue.use(InertiaApp)
Vue.component('d-grid', DGrid);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.component('Grid', Grid);
Vue.component('grid-toolbar', GridToolbar);
Vue.component('grid-norecords', GridNoRecords);
Vue.component('dropdownlist', DropDownList);
Vue.component('loading-button', LoadingButton);
Vue.component('GridColumnMenuSort', GridColumnMenuSort);
Vue.component('GridColumnMenuFilter', GridColumnMenuFilter);
Vue.component("k-dialog", Dialog);
Vue.component("dialog-actions-bar", DialogActionsBar);
Vue.component('k-input', Input);
Vue.component('k-numerictextbox', NumericTextBox);
Vue.component('datepicker', DatePicker);

Vue.use(Toasted);

// options to the toast
let my_app_error_options = {
  type	: 'error',
  iconPack: 'fontawesome',
  icon : 'exclamation-triangle',
  action: {
    text : 'Fermer',
    onClick : (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
  duration: 15000,
  position: 'bottom-center'
};

// register the toast with the custom message
Vue.toasted.register('my_app_error',
  (payload) => {

      // if there is no message passed show default message
      if(!payload.message) {
        return "&nbsp; Erreur réseau, veuillez vérifier votre connexion internet!"
      }

      // if there is a message show it with the message
      return "&nbsp; Oops.. " + payload.message;
  },
  my_app_error_options
)

const app = document.getElementById('app')


new Vue({
    render: h => h(InertiaApp, {
      props: {
        initialPage: JSON.parse(app.dataset.page),
        resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
        // transformProps: props => {
        //   console.log(props)
        //   return {
        //     ...props,
        //   }
        // },
      },
    }),
}).$mount(app)
